<template>
  <div>
    <cx-dialog v-if='showForm'
               :visible="showForm"
               :title='title'
               :rules='rules'
               :model='form'
               width="60%"
               :top="'3vh'"
               @ok='save'
               @close='showForm = false'>
      <el-tabs v-model="activeName">
        <el-tab-pane label="参保人信息" name="person">
          <el-row>
            <el-col :span="6">
              姓名：{{form.emp_name}}
            </el-col>
            <el-col :span="6">
              证件号：{{form.id_card}}
            </el-col>
            <el-col :span="6">
              性别：{{form.sex | sex}}
            </el-col>
            <el-col :span="6">
              民族：{{form.nation}}
            </el-col>
          </el-row>
          <el-row style="margin-bottom:28px">
            <el-col :span="6">
              户口性质:{{form.hold_nature}}
            </el-col>
            <el-col :span="6">
              户口所在地:{{form.addr}}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <h4 style="color:green">办理业务内容：公积金</h4>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="公积金" name="fund">
          <el-row>
            <el-col :span="8">
              <el-form-item label="参保地区" prop='social_area_list'>
                <cx-cascader v-model="form.social_area_list" :options="socialAreaList" :clearable="false" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="参保方式" prop='type'>
                <cx-radio :options='typeList' v-model='form.type'/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="公积金缴费基数" prop='apply_salary'>
                <cx-input v-model='form.apply_salary'/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开始缴纳时间" prop='effective_date'>
                <cx-select :options="beginMonthList" v-model="form.effective_date" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </cx-dialog>

    <cx-dialog v-if='showSupplementForm'
               :visible="showSupplementForm"
               :title='title'
               :rules='supplementRules'
               :model='supplementForm'
               width="40%"
               :showOkBtn="true"
               @ok='saveSupplement'
               @close='showSupplementForm = false'>
      <div>
        <el-row>
          <el-col :span="24">
            姓名：{{selectedRows[0].emp_name}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            证件号：{{selectedRows[0].id_card}}
          </el-col>
        </el-row>
        <el-row style="margin-bottom:18px">
          <el-col :span="24">
            部门：{{selectedRows[0].dept_name}}
          </el-col>
        </el-row>
        <el-row style="margin-bottom:18px">
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
        <el-row style="margin-left:38px">
          <el-col :span="12">
            参保地区：{{selectedRows[0].insured_area}}
          </el-col>
        </el-row>
        <el-row style="margin-left:38px">
          <el-col :span="12">
            公积金缴费基数：{{selectedRows[0].apply_salary}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="补缴月份："  prop='monthList' >
              <cx-checkbox v-model="supplementForm.monthList" :options='ymList'/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <h4 style="color:green">提示：已缴公积金月份不可选</h4>
          </el-col>
        </el-row>
      </div>
    </cx-dialog>

    <cx-dialog v-if='showStopForm'
               :visible="showStopForm"
               :title='title'
               :rules='stopRules'
               :model='stopForm'
               width="40%"
               @ok='saveStop'
               @close='showStopForm = false'>
      <div>
        <el-row>
          <el-col :span="6">
            姓名：{{stopForm.emp_name}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            证件号：{{stopForm.id_card}}
          </el-col>
        </el-row>
        <el-row style="margin-bottom:18px">
          <el-col :span="6">
            部门：{{stopForm.dept_name}}
          </el-col>
        </el-row>
        <el-row style="margin-bottom:18px">
          <el-col :span="24">
            <hr>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="减员生效时间" prop='effective_date'>
              <cx-select :options="beginMonthList" v-model="stopForm.effective_date" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </cx-dialog>

    <cx-query-condition :loading="loading" @query="query"
                        @reset='resetQueryCondition'>
      <el-row>
        <el-col :span="6">
          <el-form-item label="流程号/姓名/证件号/工号">
            <cx-input v-model="queryCondition.keyword"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="部门">
            <cx-select :options="deptList" v-model="queryCondition.dept" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="员工类型">
            <cx-select :options="empTypeList" v-model="queryCondition.type" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="公积金状态">
            <cx-select :options="CONST.HR_SOCIAL_STATUS" v-model="queryCondition.status" />
          </el-form-item>
        </el-col>
      </el-row>
    </cx-query-condition>

    <cx-btn-group>
      <el-button type="success" icon="el-icon-refresh" size='mini' :loading="loading"
                 @click='query'>刷新</el-button>
      <el-button type="primary" icon="el-icon-plus" size='mini'
                 @click='add'>上公积金</el-button>
      <el-button type="warning" icon="el-icon-warning" size='mini'
                 @click='stop'>停公积金</el-button>
      <el-button type="primary" icon="el-icon-edit" size='mini'
                 @click='supplement'>补缴</el-button>
    </cx-btn-group>

    <el-table v-loading="loading" :data="data"
              border
              highlight-page-row
              size='mini'
              style="width:100%;"
              @selection-change='handleSelectionChange'>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="emp_name" label="姓名" width="150"></el-table-column>
      <el-table-column prop="id_card" label="证件号" width="200"></el-table-column>
      <el-table-column prop="dept_name" label="部门" width="150"></el-table-column>
      <el-table-column prop="position" label="职位" width="150"></el-table-column>
      <el-table-column prop="type" label="员工类型" width="150" :formatter="Filter.fmEmployeeStatus"></el-table-column>
      <el-table-column prop="status" label="公积金状态" width="150" :formatter="Filter.fmSocialStatus"></el-table-column>
      <el-table-column prop="apply_salary" label="公积金缴纳基数" width="150" align="right" :formatter="Filter.fmMoney"></el-table-column>
    </el-table>
    <cx-pagination :pageData="queryCondition"
                   @sizeChange='query'
                   @pageChange='query' />

  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: 'fund',
        loading: false,
        data: [],
        selectedRows: [],

        showForm: false,
        showStopForm: false,
        showSupplementForm: false,
        showSocDiv1: false,
        showSocDiv2: false,

        typeList: [{id:1,name:'新参统'},{id:2,name:'转入'}],
        speTypeList: [{id:1,name:'工人'},{id:2,name:'干部'}],
        statusList: [{id:1,name:'有'},{id:2,name:'无'}],
        socialAreaList: [
          {id:'北京',label:'北京',children: [{id:'北京市',label:'北京市'}]},
          {id:'天津',label:'天津',children: [{id:'天津市',label:'天津市'}]},
        ],
        serTypeList: [],
        insTypeList: [],
        billStatusList: [],
        bankList: [],
        deptList: [],
        empTypeList: [],
        socStatusList: [],
        beginMonthList: [],

        form: {
          social_area_list: [],
          type: null,
          apply_salary: '',
          effective_date: ''
        },
        supplementForm: {
          insured_area: '',
          apply_salary: '',
          monthList: []
        },
        stopForm: {
          effective_date:''
        },

        queryCondition: {
          total: this.CONST.PAGINATION.TOTAL,
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.ROWS,
          sort: 'id',
          order: 'desc',

          emp_name: '',
          dept: null,
          type: null, 
          status: null,
        },
        rules: {
          social_area_list: [{required: true, trigger: 'blur', message: '请选择参保地区'}],
          type: [{required: true, trigger: 'blur', message: '请选择参保方式'}],
          apply_salary: [{required: true, trigger: 'blur', message: '请输入缴费基数'}],
          effective_date: [{required: true, trigger: 'blur', message: '请输入开始缴纳时间'}],
        },
        supplementRules: {
          monthList: [{type: 'array', trequired: true, trigger: 'change', message: '请选择补缴月份'}],
        },
        stopRules: {
          effective_date: [{required: true, trigger: 'blur', message: '请选择日期'}],
        },
      }
    },
    mounted() {
      this.getBeginDateList();
      this.queryDeptList();
      this.queryDictionaries();
      this.query();
    },
    methods: {
      handleSelectionChange(rows) {
        this.selectedRows = rows;
      },
      resetQueryCondition() {
        this.Util.reset(this.queryCondition);
      },
      queryDeptList() {
        this.post('/client-dept/list', {
          token: this.$store.state.user.token,
        }).then(resp => {
          if (resp) {
            if (resp.data.success) {
              this.deptList = [];
              if(resp.data.rows && resp.data.rows.length > 0) {
                resp.data.rows.forEach(dept => {
                  this.deptList.push(dept);
                });
              }
            }
          }
        });
      },
      queryDictionaries() {
        this.post('/sys-dictionaries/list', {
            types: '31, 46, 48, 52, 53, 54',
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.MAX_ROWS,
        }).then(resp => {
          if (resp) {
            if (resp.data.success) {
              let rows = resp.data['rows'] || [];
              rows.forEach(row => {
                switch (row.type) {
                  case 31:
                    this.empTypeList.push(row);
                    break;
                  case 48:
                    row.id = row.name;  
                    this.bankList.push(row);
                    break;
                  case 52:
                    this.billStatusList.push(row);
                    break;
                  case 53:
                    this.serTypeList.push(row);
                    break;
                  case 54:
                    this.insTypeList.push(row);
                    break;
                }
              });
            }
          }
        });
      },
      getBeginDateList() {
        //获取未来3个月的年月
        let year = new Date().getFullYear();
        let month = new Date().getMonth()+1;
        let year1 = year;
        let year2 = year;
        let year3 = year;
        let month1 = month + 1;
        let month2 = month + 2;
        let month3 = month + 3;
        switch(month){
          case 10:
            year3 = year + 1;
            month3 = month - 9;
            break;
          case 11:
            year2 = year + 1;
            year3 = year + 1;
            month2 = month - 10;
            month3 = month - 9;
            break;
          case 12:
            year1 = year + 1;
            year2 = year + 1;
            year3 = year + 1;
            month1 = month - 11;
            month2 = month - 10;
            month3 = month - 9;
            break;
        }
        let lastMonthThree = year1+"-"+((month1 < 10) ? ('0' + month1) : month1);
        let lastMonthTwo = year2+"-"+(((month2) < 10) ? ('0' + (month2)) : (month2));
        let lastMonthOne = year3+"-"+(((month3) < 10) ? ('0' + (month3)) : (month3));
        this.beginMonthList = [];
        this.beginMonthList.push({id:lastMonthThree + '-01',name:lastMonthThree},{id:lastMonthTwo + '-01',name:lastMonthTwo},{id:lastMonthOne + '-01',name:lastMonthOne});
      },
      query() {
        this.loading = true;
        let postData = this._.cloneDeep(this.queryCondition);
        this.Util.changeIdToInt(postData);
        postData.status = parseInt(postData.status);
        postData.type = parseInt(postData.type);
        this.post('/fund/overview', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              // for(let i=0;i<resp.data.rows.length;i++){
              //   resp.data.rows[i].status_name = this.socStatusMap[resp.data.rows[i].status]
              // }
              this.data = resp.data['rows'] || [];
              this.queryCondition.total = resp.data['total'];
            }
          }
        })
      },
      add() {
        if (this.selectedRows.length !== 1) {
          this.error(this.CONST.TIP.SELECT_ONE_FIRST);
        }else if(this.selectedRows[0].status != 2){
          this.error('请检查员工的公积金状态');
        } else {
          this.loading = true;
          if(this.selectedRows[0].id) {
            this.post('/client-employee/list', {
              id: this.selectedRows[0].id
            }).then(resp => {
              if(resp) {
                this.loading = false;
                if(resp.data['success']) {
                  let rows = resp.data['rows'] || [];
                  if(rows && rows.length > 0) {
                    this.selectedRows[0].employeeDetail = rows[0];
                    this.Util.reset(this.form);
                    this.form.type = null;
                    this.form.activeName = 'info';
                    this.title = '上公积金';
                    this.form = this._.cloneDeep(this.selectedRows[0]);
                    this.form.apply_salary = '';
                    this.showForm = true;
                  }
                }
              }
            })
          }
        }
      },
      save() {
        this.loading = true;
        this.showForm = false;
        let postData = this._.cloneDeep(this.form);
        postData.emp_id = postData.id;
        postData.status = this.billStatusList[1].id;  //等待客服处理
        postData.ins_type = this.insTypeList[1].id;  //汇缴
        if(postData.type == 1){
          postData.type = this.serTypeList[0].id;
        }else if(postData.type == 2){
          postData.type = this.serTypeList[2].id;
        }
        postData.feedback = "-";
        postData.feedbacker = 20001;
        this.post('/bill/add', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              let addPostData = {};
              addPostData.emp_id = postData.emp_id;
              addPostData.status = 3;
              addPostData.apply_type = 1;
              addPostData.insurance_type = postData.type;
              addPostData.apply_salary = parseInt(postData.apply_salary);
              addPostData.begin_date = postData.effective_date;
              addPostData.insured_area = postData.social_area_list.join(' ');
              this.post('/fund/employee-add', addPostData).then(resp => {
                this.loading = false;
                if(resp) {
                  if(resp.data['success']) {
                    this.success('服务单提交成功，请等待客服处理！');
                    this.query()
                  }else{
                    this.error('服务单提交失败，请联系客服人员！');
                    this.query()
                  }
                }
              })
            }else{
              this.error('服务单提交失败，请联系客服人员！');
              this.query()
            }
          }
        })
      }, 
      supplement() {
        if (this.selectedRows.length !== 1) {
          this.error(this.CONST.TIP.SELECT_ONE_FIRST);
        }else if(this.selectedRows[0].status != 1){
          this.error('请检查员工的公积金状态');
        } else {
        this.loading = true;
        this.Util.reset(this.supplementForm);
        this.title = '为员工办理业务';
        let year = new Date().getFullYear();
        let month = new Date().getMonth()+1;
        let year1 = year;
        let year2 = year;
        let year3 = year;
        let month1 = month - 3;
        let month2 = month - 2;
        let month3 = month - 1;
        switch(month){
          case 1:
            year1 = year - 1;
            year2 = year - 1;
            year3 = year - 1;
            month1 = month + 9;
            month2 = month + 10;
            month3 = month + 11;
            break;
          case 2:
            year1 = year - 1;
            year2 = year - 1;
            month1 = month + 9;
            month2 = month + 10;
            break;
          case 3:
            year1 = year - 1;
            month1 = month + 9;
            break;
        }
        let lastMonthThree = year1+"-"+((month1 < 10) ? ('0' + month1) : month1);
        let lastMonthTwo = year2+"-"+(((month2) < 10) ? ('0' + (month2)) : (month2));
        let lastMonthOne = year3+"-"+(((month3) < 10) ? ('0' + (month3)) : (month3));
        this.ymList = [];
        this.ymList.push({id:lastMonthThree + '-01',name:lastMonthThree},{id:lastMonthTwo + '-01',name:lastMonthTwo},{id:lastMonthOne + '-01',name:lastMonthOne});
      let postData = {};
        postData.emp_id = this.selectedRows[0].id;
        postData.begin_curr_date = lastMonthThree+"-01";
        postData.end_curr_date = lastMonthOne+"-01";
        this.post('/fund/history', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              let currData = resp.data['rows'] || [];
              for(let i=0; i<currData.length; i++){
                switch(currData[i].curr_date){
                  case this.ymList[0].id:
                    this.ymList[0].disabled = true;
                    break;
                  case this.ymList[1].id:
                    this.ymList[1].disabled = true;
                    break;
                  case this.ymList[2].id:
                    this.ymList[2].disabled = true;
                    break;
                }
              }
              this.supplementForm.monthList = [];
            }
          }
        })
        this.showSupplementForm = true;
        }
      },
      saveSupplement() {
        this.loading = true;
        this.showSupplementForm = false;
        let postData = this._.cloneDeep(this.supplementForm);
        postData.feedback = "申请补缴" + postData.monthList.join(',') + "月份的公积金";
        postData.emp_id = this.selectedRows[0].id;
        postData.status = this.billStatusList[1].id;  //等待客服处理
        postData.type = this.serTypeList[1].id;  //公积金-补缴
        postData.ins_type = this.insTypeList[1].id;  //补缴
        postData.feedbacker = 20001;
        let year = new Date().getFullYear();
        let month = new Date().getMonth()+1;
        postData.effective_date = year + "-"+month + "-01";
        this.post('/bill/add', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              let PostData1 = {};
              PostData1.emp_id = postData.emp_id;
              PostData1.curr_date = this.moment(Date.now()).format("YYYY-MM-01");
              this.post('/social/social-fund-detail', PostData1).then(resp => {
                if(resp) {
                  if(resp.data['success'] && resp.data['rows']) {
                    let postData2 = resp.data['rows'][0] || [];
                    postData2.rrt_name = postData2.hold_nature;
                    postData2.base = postData2.sc_apply_salary;
                    postData2.PU_base = postData2.pu_base;
                    postData2.IBH_base = postData2.ibh_base;
                    postData2.curr_dates = postData.monthList;
                    postData2.ss_type = 3;
                    this.post('/fund/history-add', postData2).then(resp => {
                      if(resp) {
                        if(resp.data['success']) {
                          this.success('服务单提交成功，请等待客服处理！');
                           this.query()
                        }else{
                          this.error('服务单提交失败，请联系客服人员！');
                          this.query()
                        }
                      }
                    })
                  }else{
                    this.error('社保缴费参数为空，请联系客服人员！');
                    this.query()
                  }
                }
              })
            }else{
              this.error('服务单提交失败，请联系客服人员！');
              this.query()
            }
          }
        })
      },
      stop() {
        if (this.selectedRows.length !== 1) {
          this.error(this.CONST.TIP.SELECT_ONE_FIRST);
        }else if(this.selectedRows[0].status != 1){
          this.error('请检查员工的公积金状态');
        } else {
        this.Util.reset(this.stopForm);
        this.title = '公积金减员';
        this.stopForm = this._.cloneDeep(this.selectedRows[0]);
        this.showStopForm = true;
        }
      },
      saveStop() {
        this.loading = true;
        this.showStopForm = false;
        let postData = this._.cloneDeep(this.stopForm);
        postData.feedback = "申请" + postData.effective_date + "减员";
        postData.emp_id = postData.id;
        postData.status = this.billStatusList[1].id;  //等待客服处理
        postData.type = this.serTypeList[3].id;  //公积金-减员
        postData.ins_type = this.insTypeList[0].id;  //汇缴
        postData.feedbacker = 20001;
        this.post('/bill/add', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              //添加工单成功后，修改员工公积金状态
              let postData_modify = {};
              postData_modify.emp_id = postData.emp_id
              postData_modify.status = 4;
              postData_modify.end_date = postData.effective_date;
              this.post('/fund/employee-modify', postData_modify).then(resp => {
                if(resp) {
                  if(resp.data['success']) {
                    this.success('服务单提交成功，请等待客服处理！');
                    this.query()
                  }else{
                    this.error('服务单提交失败，请联系客服人员！');
                    this.query()
                  }
                }
              })
            }else{
              this.error('服务单提交失败，请联系客服人员！');
              this.query()
            }
          }
        })
      },
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/insurance/fund/list.vue